/**
 * Legacy viewer keys we can drop if `cognito-user` cannot be persisted (quota).
 * Do not include live `grid-viewer-state*` keys — evicting those on auth init
 * would wipe Results tabs on refresh when localStorage is near quota.
 */
const LS_KEYS_EVICT_FOR_AUTH_QUOTA = [
  'viewer-state',
  'viewer-state-echart',
  'viewer-state-pathway',
  'viewer-state-workflow',
  'results-viewer-order',
] as const

export function evictLowPriorityLocalStorageForAuth(): void {
  for (const k of LS_KEYS_EVICT_FOR_AUTH_QUOTA) {
    try {
      localStorage.removeItem(k)
    } catch {
      /* ignore */
    }
  }
}

function isQuotaExceededError(error: unknown): boolean {
  return (
    error instanceof DOMException
      ? error.name === 'QuotaExceededError'
      : (error as {name?: string})?.name === 'QuotaExceededError'
  )
}

/**
 * Writes a key to localStorage; on quota, evicts low-priority keys once and retries.
 * @returns whether the value was stored
 */
export function setLocalStorageItemWithQuotaRetry(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value)
    return true
  } catch (error: unknown) {
    if (!isQuotaExceededError(error)) {
      throw error
    }
  }
  evictLowPriorityLocalStorageForAuth()
  try {
    localStorage.setItem(key, value)
    return true
  } catch (error: unknown) {
    if (!isQuotaExceededError(error)) {
      throw error
    }
  }
  return false
}
